module.exports = __webpack_public_path__ + "static/media/bike-image-02-01.f06fc828.png";